// src/components/User/Home/HomePage/FounderProblemsSection.js
import React from "react";

const PROBLEMS = [
    {
        id: "Problem 01",
        quote:
            "People try us once and don't come back, and I can't see where in the journey we're losing them.",
    },
    {
        id: "Problem 02",
        quote:
            "I know we're losing money to referral or offer abuse, but I don't know how to stop it.",
    },
    {
        id: "Problem 03",
        quote:
            "We want to reward our best customers, but I don't actually know who they are.",
    },
    {
        id: "Problem 04",
        quote:
            "We want to run real experiments, but don't have the setup or clarity to do it properly.",
    },
    {
        id: "Problem 05",
        quote:
            "We want to launch a new category, but I don't know where the real gap is.",
    },
];

export default function FounderProblemsSection() {
    return (
        <section
            id="founder-problems"
            className="px-6 md:px-12 lg:px-36 py-10 md:py-12 scroll-mt-14 border-t border-[rgba(0,0,0,0.06)]"
            style={{ backgroundColor: "var(--bg-base)" }}
        >
            <div className="max-w-[900px] mx-auto">
                {/* SECTION INTRO */}
                <p
                    className="text-base sm:text-lg mb-6 max-w-[620px] font-normal leading-relaxed"
                    style={{ color: "var(--text-secondary)" }}
                >
                    These are the conversations I actually have with founders, usually before they’ve put a name to the problem.
                </p>

                {/* PROBLEMS LIST */}
                <div className="divide-y divide-[rgba(0,0,0,0.08)]">
                    {PROBLEMS.map((item, idx) => (
                        <div key={idx} className="py-5 first:pt-0">
                            <span
                                className="inline-block text-xs font-mono font-medium tracking-wider uppercase mb-2"
                                style={{ color: "var(--color-primary)" }}
                            >
                                {item.id}
                            </span>
                            <p
                                className="text-lg sm:text-xl md:text-[1.3rem] font-medium leading-relaxed"
                                style={{ color: "var(--text-primary)" }}
                            >
                                “{item.quote}”
                            </p>
                        </div>
                    ))}
                </div>

                {/* TRANSITION TO SELECTED WORK */}
                <div className="mt-8 pt-6 border-t border-[rgba(0,0,0,0.08)]">
                    <p
                        className="text-base sm:text-lg font-semibold"
                        style={{ color: "var(--text-primary)" }}
                    >
                        Recognize one? That’s usually where we start.
                    </p>
                </div>
            </div>
        </section>
    );
}
